import { ApiService, CliaCertificate } from "pwapi";

import { CliaCertificateOption } from "../edit/ResourceOptions";
import SelectSearchInput from "../edit/SelectSearchInput";

const mapCertsToOptions = (certs: CliaCertificate[], allLabel: string) => {
  return [
    {
      value: "",
      label: allLabel,
      object: { name: allLabel },
    },
    ...certs
      .filter((cert) => cert.id && cert.name && cert.number)
      .map((cert) => ({
        value: `${cert.name} - ${cert.number},${cert.id}`,
        label: cert.name,
        object: cert,
      })),
  ];
};

const CliaCertificateFilter = ({
  allLabel,
  onChange,
  value,
  label = "TC CLIA Certificate",
}: {
  allLabel: string;
  onChange: Function;
  value?: string;
  label?: string;
}) => {
  const content = value?.match(/(.*),(\d*)$/)?.[1] || undefined;

  return (
    <SelectSearchInput
      label={label}
      field="grossedByCert"
      filter="name"
      onChange={onChange}
      serviceOptions={{
        hasLabId: true,
      }}
      mapToOptions={(certs: CliaCertificate[]) =>
        mapCertsToOptions(certs, allLabel)
      }
      apiService={ApiService.listCliaCertificates}
      component={CliaCertificateOption}
    >
      {content ? content : allLabel}
    </SelectSearchInput>
  );
};

export default CliaCertificateFilter;
